import ColorChooser from "../../../../src/components/ColorChooserExample";
import * as React from 'react';
export default {
  ColorChooser,
  React
};